import { isRef } from '@vue/reactivity'
export default defineNuxtPlugin(() => {
  return {
    provide: {
      disableReactive: (data: any): any => {
        return disableReactive(data)
      }
    }
  }
})

const disableReactive = (data: any): any => {
  if (data instanceof FormData) {
    return data
  }
  if (Array.isArray(data)) {
    return data.map((d) => {
      return disableReactive(d)
    })
  } else if (typeof data === 'object') {
    data = { ...toRaw(data) }
    Object.keys(data).forEach((key) => {
      if (!(data[key] instanceof URLSearchParams || data[key] instanceof FormData)) {
        const raw = toRaw(data[key])
        if (Array.isArray(raw)) {
          data[key] = raw.map((o) => {
            return disableReactive(o)
          })
        } else if (raw !== null && typeof raw === 'object') {
          data[key] = { ...disableReactive(raw) }
        } else {
          data[key] = raw
        }
      }
    })
    return data
  } else {
    if (isReactive(data) || isRef(data)) {
      return toRaw(data)
    }
    return data
  }
}
